var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{staticClass:"text-center"},[_c('v-btn',{staticClass:"primary rounded",attrs:{"to":"/"}},[_vm._v("Retour en page d'accueil")])],1),_c('v-col',{staticClass:"text-center"},[_c('v-btn',{staticClass:"primary rounded",on:{"click":_vm.goBack}},[_vm._v("Retour en page prédédente")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }